<div class="footer">
  <div class="zaver-logo-container">
    <div *ngIf="shouldDisplayLocaleSelector" class="locale-selector">
      <select-locale
        [shouldDisplayMenuAbove]="true"
        [activeLocale]="activeLocale"
        [locales]="localeOptions"
        (selectOption)="localeChanged($event)"
      ></select-locale>
    </div>
    <app-zaver-icon [size]="24" name="zaverLogo" (click)="report()"></app-zaver-icon>
  </div>

  <div *ngIf="shouldDisplayDisclaimer" class="footer-disclaimer-wrapper">
    <div class="footer-disclaimer-container">
      <hr class="loan-warning-divider" />
      <p class="loan-warning-text">
        <img
          class="loan-warning-img"
          src="assets/icon/Icon_Warning.svg"
          alt=""
        />
        <b>Att låna kostar pengar!</b><br />
        Om du inte kan betala tillbaka skulden i tid riskerar du en
        betalningsanmärkning. Det kan leda till svårigheter att få hyra bostad,
        teckna abonnemang och få nya lån. För stöd, vänd dig till budget- och
        skuldrådgivningen i din kommun. Kontaktuppgifter finns på
        konsumentverket.se.
      </p>
    </div>
  </div>
</div>
